import React from 'react';
import useReduxModal from 'Hooks/reduxHelperHooks/useReduxModal';
import appStyles from 'Routes/Routes.css';

import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useUploaderContext } from '../components/Uploader/context';

/**
 *
 * Generic success handler for bulk uploader in list management
 * PCI and non PCI lists need to reroute user up a route in the tree
 * And show a success modal
 */
function useBulkListChunkingCompleteAddSuccessModal() {
    const { fileDetails, listName, listType } = useUploaderContext();
    const { t } = useTranslation();
    const { clearAll, addModal } = useReduxModal();
    const history = useHistory();
    const location = useLocation();
    const errorRowLength = Number(fileDetails?.errorRows?.length);

    const cb = React.useCallback(() => {
        clearAll();
        const routeToGoTo = location.pathname.split('/').slice(0, 3).join('/');
        history.push(routeToGoTo);

        addModal({
            id: 'list-success',
            status: 'success',
            title: t('singleListBulkUpload.entriesUploaded', { listType }),
            content: (
                <>
                    {t('singleListBulkUpload.successfullyUploadedFile')}
                    <br />
                    <span className={appStyles.bold}>
                        {t('singleListBulkUpload.successRowCount', {
                            rowCount: fileDetails.totalNumberOfRows - errorRowLength
                        })}
                    </span>
                    {t('singleListBulkUpload.toList', { listName })}
                </>
            ),
            cancelText: t('Close'),
            onClose: () => {}
        });
    }, [
        addModal,
        clearAll,
        errorRowLength,
        fileDetails.totalNumberOfRows,
        history,
        listName,
        listType,
        location.pathname,
        t
    ]);

    return cb;
}

export default useBulkListChunkingCompleteAddSuccessModal;
